import React, { useState, useEffect } from "react";
import axios from "../api/api";
import "./UserOrders.css";
import Layout from "../components/Layout";
const UserOrders = () => {
    const [orders, setOrders] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);

    useEffect(() => {
        const fetchOrders = async () => {
            try {
                const response = await axios.get(`/orders/my-orders`, {
                    params: { page: currentPage, limit: 12 },
                });
                setOrders(response.data.orders);
                setTotalPages(response.data.totalPages);
            } catch (error) {
                console.error("Error fetching orders:", error);
            }
        };

        fetchOrders();
    }, [currentPage]);

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    return (
        <Layout>
            <div className="user-order-container">
                <h2>Danh sách đơn hàng</h2>
                {orders.length === 0 ? (
                    <p>Bạn chưa có đơn hàng nào.</p>
                ) : (
                    <div className="order-list">
                        {orders.map((order) => (
                            <div key={order._id} className="order-item">
                                <h4>Đơn hàng #{order._id}</h4>
                                <p>Ngày đặt: {new Date(order.createdAt).toLocaleDateString('vi-VN')}</p>
                                <p>
                                    Địa chỉ giao hàng:{" "}
                                    {`${order.deliveryAddress.detailedAddress}, ${order.deliveryAddress.wardId?.wardName}, ${order.deliveryAddress.districtId?.districtName}, ${order.deliveryAddress.provinceId?.provinceName}`}
                                </p>
                                <p>Tổng tiền: {order.totalAmount.toLocaleString()} VND</p>
                                <p>Trạng thái: {order.orderStatus}</p>
                                <div className="order-items">
                                    <h5>Sản phẩm:</h5>
                                    <ul>
                                        {order.items.map((item) => (
                                            <li key={item.productId._id}>
                                                {item.productId.name} - {item.quantity} x {item.price.toLocaleString()} VND
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        ))}
                    </div>
                )}

                {/* Pagination */}
                <div className="pagination">
                    {[...Array(totalPages)].map((_, index) => (
                        <button
                            key={index}
                            className={`page-btn ${currentPage === index + 1 ? "active" : ""}`}
                            onClick={() => handlePageChange(index + 1)}
                        >
                            {index + 1}
                        </button>
                    ))}
                </div>
            </div>
        </Layout>
    );
};

export default UserOrders;
